<template>
  <div class="w-full">
    <div class="flex items-center justify-between">
      <label class="vs-input--label">{{ sectionLabel }}</label>
      <vs-button v-if="editable" size="small" type="border" @click="showModal = true">
        Add skills
      </vs-button>
    </div>
    <div v-if="skillsDetailedList.length" class="text-sm text-gray-600 flex flex-wrap gap-2 mt-2 mb-2">
      <vx-tooltip
        v-for="skill in skillsDetailedList"
        :key="skill.skillId"
        :text="skill.taxonomyPath"
      >
        <vs-chip
          transparent
          :closable="isClosable(skill)"
          @click.native.stop="handleSkillDeleted(skill)"
        >
          {{ skill.name }}
        </vs-chip>
      </vx-tooltip>
    </div>
    <div v-else class="text-sm text-gray-400 px-5 mt-5 mb-5">
      No skills assigned
    </div>
    <vs-alert
      color="warning"
      icon-pack="feather"
      icon="icon-info"
      class="h-auto"
      v-if="skillsEdited && skillsEdited.length > 0"
    >
      <span class="text-sm">You have unsaved taxonomy changes. Remember to save the {{ contentType }} before leaving the page.</span>
    </vs-alert>
    <SkillsPopup v-if="editable" v-model="showModal" @skills-added="handleSkillsAdded"/>
  </div>
</template>

<script>
import SkillsPopup from '@/components/SkillsPopup.vue'
import { getContentDetailedSkillsList, isLeaf, taxonomyPathFromStrToArray } from '@/utils/skills.js'
import CONSTANTS from '@/constants';
import { mapGetters } from 'vuex';

export default {
  name: 'Skills',
  components: {
    SkillsPopup,
  },
  props: {
    contentType: {
      type: String,
      required: true,
    },
    skillsList: {
      type: Array,
      default: () => [],
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
    }
  },
  computed: {
    ...mapGetters('taxonomy', {
      getLabTaxonomy: 'getLabTaxonomy',
      getVideoTaxonomy: 'getVideoTaxonomy',
    }),
    skillsDetailedList() {
      return getContentDetailedSkillsList(this.contentType, this.skillsList)
    },
    sectionLabel() {
      return CONSTANTS.CONTENT_TYPE_SKILL_LABELS[this.contentType] || 'Taxonomy values'
    },
    editable() {
      return isLeaf(this.contentType) && this.editMode
    },
    skillsEdited() {
      switch (this.contentType) {
        case CONSTANTS.CONTENT_TYPES.LAB:
          return this.getLabTaxonomy ? this.getLabTaxonomy.addedSkills : []
        case CONSTANTS.CONTENT_TYPES.VIDEO:
          return this.getVideoTaxonomy ? this.getVideoTaxonomy.addedSkills : []
        default:
          return []
      }
    },
  },
  methods: {
    handleSkillsAdded(newSkills) {
      const payload = newSkills.map(skill => ({
        skillId: skill.id,
        taxonomyPath: taxonomyPathFromStrToArray(skill.taxonomy_path),
      }))
      this.$emit('add:skillsList', payload)
    },
    handleSkillDeleted(deletedSkill) {

      const payload = {
        skillId: deletedSkill.skillId,
        taxonomyPath: taxonomyPathFromStrToArray(deletedSkill.taxonomyPath),
      }
      this.$emit('delete:skillsList', payload)
    },
    isClosable(skill) {
      return this.skillsEdited && this.skillsEdited.some(editedSkill => editedSkill.skillId === skill.skillId)
    },
  },
}
</script>
